const ckEditorToolbar = [
	'heading', '|', 'undo', 'redo', '|', 'bold', 'italic', 'bulletedList', 'NumberedList', '|', 'blockQuote'
]


export {ckEditorToolbar}